module.exports = __webpack_public_path__ + "img/water.f6b0b6b7.svg";